module.exports = __webpack_public_path__ + "static/img/r_004.69de52e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_004.jpg
// module id = Vky6
// module chunks = 1